import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import FormControl from "@mui/material/FormControl";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { Container, Typography } from "@mui/material";
import { getData, writeData } from "../functions/writeData";
import imageUpload from "../functions/uploadImage";
import { useParams } from "react-router-dom";
import { setDoc, doc, getDoc } from "firebase/firestore";
import { fireDB } from "../config";
import { Avatar, Box } from "@mui/material";
import { Close, FileUpload } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function AddProduct() {
  const params = useParams();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category_id: "",
      name: "",
      description: "",
      price: "",
      cals: "",
      file: "",
      sizes: [],
      flavours: [],
      extras: [],
    },
  });
  const {
    fields: sizes,
    append: appendSize,
    remove: removeSize,
  } = useFieldArray({
    control,
    name: "sizes",
  });
  const {
    fields: flavours,
    append: appendFlavour,
    remove: removeFlavour,
  } = useFieldArray({
    control,
    name: "flavours",
  });
  const {
    fields: extras,
    append: appendExtra,
    remove: removeExtra,
  } = useFieldArray({
    control,
    name: "extras",
  });

  const [colData, setColData] = React.useState();

  async function collectionData() {
    let data = await getData("categories");
    setColData(data);
  }

  React.useEffect(() => {
    collectionData();
  }, []);

  useEffect(() => {
    if (params.productId) {
      handleCategory();
    }
  }, [params]);

  async function handleCategory() {
    const docRef = doc(fireDB, "products", params.productId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const productData = docSnap.data();
      console.log(productData);
      setValue("category_id", productData.category_id);
      setValue("name", productData.name);
      setValue("description", productData.description);
      setValue("price", productData.price);
      setValue("cals", productData.cals);
      setValue("position", productData.position);
      setValue("image", productData.image);

      productData.sizes.forEach((size, index) => {
        appendSize({ ...size, id: index }); // Assuming each size has a property 'name'
      });

      productData.extras.forEach((extra, index) => {
        appendExtra({ ...extra, id: index }); // Assuming each extra has a property 'name'
      });
      productData.flavours.forEach((flavour, index) => {
        appendFlavour({ ...flavour, id: index }); // Assuming each extra has a property 'name'
      });
    } else {
      console.log("No such document!");
    }
  }

  const onSubmit = async (data) => {
    let image;

    if (data.file) {
      image = await imageUpload(data.file[0]);
    }

    if ((image !== null || data.image !== undefined) && data.name !== null) {
      let productData = {
        category_id: data.category_id,
        name: data.name,
        description: data.description,
        price: data.price,
        cals: data.cals,
        position: data.position,
        image: image ? image : data.image,
        sizes: data.sizes,
        extras: data.extras,
        flavours: data.flavours,
      };
      console.log(productData);
      if (params.productId) {
        await setDoc(doc(fireDB, "products", params.productId), productData);
        alert("Update productId");
      } else {
        await writeData("products", productData);
        alert("Create productId");
      }
      navigate("/dashboard/products");
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography
        variant="h5"
        gutterBottom
        sx={{ fontWeight: "bold" }}
        align="center"
      >
        Add a Product
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="subtitle2">Product Name</Typography>
        <TextField {...register("name", { required: true })} fullWidth />
        {errors.name && <span>This field is required</span>}

        <Typography variant="subtitle2">Category</Typography>
        <FormControl fullWidth>
          <Select {...register("category_id", { required: true })}>
            {colData?.map((item, index) => (
              <MenuItem value={item.id} key={index}>
                {item.data.title}
              </MenuItem>
            ))}
          </Select>
          {errors.category_id && <span>This field is required</span>}
        </FormControl>
        <Typography variant="subtitle2">Calories</Typography>

        <TextField {...register("cals")} fullWidth />
        <Typography variant="subtitle2">Position</Typography>

        <TextField {...register("position", { required: true })} fullWidth />
        <Typography variant="subtitle2">Price</Typography>

        <TextField {...register("price", { required: true })} fullWidth />
        <Box sx={{ my: 1, display: "flex", justifyContent: "space-between" }}>
          <Button
            color="primary"
            component="label"
            variant="contained"
            sx={{ width: "100%", mr: 1 }}
          >
            <input
              type="file"
              {...register("file")}
              accept=".jpg, .jpeg, .png"
              hidden
            />
            <FileUpload fontSize="large" />
          </Button>
          {watch("file")?.length ? (
            <Avatar
              src={URL.createObjectURL(watch("file")[0])}
              sx={{ width: "50%", height: "100px", objectfit: "contain" }}
              variant="rounded"
            />
          ) : null}
        </Box>

        <TextareaAutosize
          name="description"
          style={{
            marginTop: "10px",
            width: "100%",
            padding: 20,
            fontSize: 18,
            minHeight: 50,
          }}
          minRows={3}
          placeholder="Description"
          {...register("description")}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexDirection: "column",
            width: "100%",
          }}
        >
          {sizes.map((size, index) => (
            <Box
              key={size.id}
              sx={{ display: "flex", gap: 1 / 2, width: "100%" }}
            >
              <TextField
                {...register(`sizes.${index}.name`)}
                fullWidth
                label={`Size ${index + 1}`}
                color="primary"
              />
              <TextField
                {...register(`sizes.${index}.price`)}
                fullWidth
                label={`Price ${index + 1}`}
                color="primary"
              />
              <Button
                variant="outlined"
                type="button"
                onClick={() => removeSize(index)}
              >
                <Close />
              </Button>
            </Box>
          ))}
          <Button
            type="button"
            onClick={() => appendSize({ name: "" })}
            variant="contained"
          >
            Add Size
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexDirection: "column",
            my: 1,
          }}
        >
          {flavours.map((flavour, index) => (
            <Box
              key={flavour.id}
              sx={{ display: "flex", gap: 1 / 2, width: "100%" }}
            >
              <TextField
                {...register(`flavours.${index}.name`)}
                fullWidth
                label={`Flavour ${index + 1}`}
                color="primary"
              />
              <Button
                type="button"
                onClick={() => removeFlavour(index)}
                variant="outlined"
              >
                <Close />
              </Button>
            </Box>
          ))}
          <Button
            type="button"
            onClick={() => appendFlavour({ name: "" })}
            variant="contained"
          >
            Add Flavour
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexDirection: "column",
            my: 1,
          }}
        >
          {extras.map((extra, index) => (
            <Box
              key={extra.id}
              sx={{ display: "flex", gap: 1 / 2, width: "100%" }}
            >
              <TextField
                {...register(`extras.${index}.name`)}
                fullWidth
                label={`Extra ${index + 1}`}
                color="primary"
              />
              <TextField
                {...register(`extras.${index}.price`)}
                fullWidth
                label={`Price ${index + 1}`}
                color="primary"
              />
              <Button
                type="button"
                onClick={() => removeExtra(index)}
                variant="outlined"
              >
                <Close />
              </Button>
            </Box>
          ))}
          <Button
            type="button"
            onClick={() => appendExtra({ name: "" })}
            variant="contained"
          >
            Add Extra
          </Button>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              my: 2,
              backgroundColor: "#E4780E",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            Add Product
          </Button>
        </Box>
      </form>
    </Container>
  );
}
